import React from 'react'
import { X } from 'lucide-react'
import './styles.scss'

export default function RejectDocumentModal({
  show,
  onClose,
  onConfirm,
  rejectItem,
  rejectReason,
  setRejectReason
}) {
  if (!show) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content reject-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Reject Document</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <p>Please provide a reason for rejecting the <strong>{rejectItem?.title}</strong>. This reason will be emailed to the student and added to their chat.</p>
          <textarea
            className="input-field"
            rows={4}
            placeholder="e.g. The document is too blurry to read."
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
          />
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" onClick={onConfirm}>Confirm Rejection</button>
        </div>
      </div>
    </div>
  )
}
